import { useState } from 'react'
import {
  Text,
  Button,
  GreyGrey90,
  Image,
  Primary13Regular,
  Primary16SemiBold,
  useNotifications,
  Flex
} from '@sequencehq/core-components'
import { TextInputField, Modal } from '@sequencehq/core-components'
import { logError } from '@sequencehq/utils'

const disableDemoEmailCapture = () =>
  window.localStorage.setItem('collectEmail', 'false')

export const CollectEmailModal = (props: { onClose: () => void }) => {
  const [email, setEmail] = useState('')
  const [emailValid, setEmailValid] = useState(false)
  const { displayNotification } = useNotifications()

  const displayCaptureErrorNotification = () => {
    displayNotification(
      'There was an error submitting your email. Please try again later.',
      { type: 'error' }
    )
  }
  const handleSubmit = () => {
    if (email.length === 0 || !emailValid) {
      return
    }

    fetch(`https://www.sequencehq.com/api/addSubscriber`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        location: 'demo'
      })
    })
      .then(res => {
        if (!res.ok) {
          displayCaptureErrorNotification()
          return
        }

        disableDemoEmailCapture()
        props.onClose()
      })
      .catch(error => {
        logError(error)
        displayCaptureErrorNotification()
      })
  }

  return (
    <Modal
      isOpen
      onClose={props.onClose}
      data-testid="collectEmail.modal"
      userClosable={false}
    >
      <Modal.Content>
        <Flex align="center" direction="column">
          <Image
            src="/img/logo.svg"
            height="64px"
            width="64px"
            alt="Sequence"
            mt="12px"
            mb={6}
          />
          <Text {...Primary16SemiBold} mb="8px">
            Welcome to Sequence
          </Text>
          <Text {...Primary13Regular} align="center" mb="24px">
            B2B companies of all sizes use Sequence to scale pricing, billing
            and invoicing workflows
          </Text>

          <Flex direction="column" gap="8px" align="center">
            <TextInputField
              data-testid="collectEmail.modal.emailInput"
              label="Please enter your work email"
              type="email"
              value={email}
              placeholder="Enter an email"
              onChange={e => {
                setEmail(e.target.value)
                setEmailValid(e.target.validity.valid)
              }}
              styles={{
                label: {
                  textAlign: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  color: GreyGrey90
                }
              }}
              width="280px"
              validationErrors={
                !emailValid && email.length > 0
                  ? [{ message: 'Please enter a valid email.' }]
                  : []
              }
            />
          </Flex>
        </Flex>
      </Modal.Content>

      <Modal.Footer>
        <Button
          data-testid="collectEmail.modal.learnMore"
          variant="secondary"
          onClick={() => window.open('https://sequencehq.com', '_blank')}
        >
          Learn more
        </Button>
        <Button
          data-testid="collectEmail.modal.submit"
          variant="primary"
          disabled={email.length === 0 || !emailValid}
          onClick={handleSubmit}
        >
          Explore demo
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
